import * as types from "./types";

export const complainInitialState = {
  //get request for all role
  allComplain: <any>[],
  allComplainLoading: false,
  allComplainError: null,
};

export const complainReducer = (state = complainInitialState, action: any) => {
  switch (action.type) {

    case types.GET_ALL_COMPLAIN_START:
      return {
        ...state,
        allComplainLoading: true,
      };
    case types.GET_ALL_COMPLAIN_SUCCESS:
      return {
        ...state,
        allComplain: action.allComplain,
        allComplainLoading: false,
      };
    case types.GET_ALL_COMPLAIN_FAILURE:
      return {
        ...state,
        allComplainError: action.allComplainError,
        allComplainLoading: false,
      };

    default:
      return state;
  }
};
